/**
 * useSeoMeta — updates document.title + all head meta tags for tour pages.
 * Call setTourMeta() once the tour data is available (from API or TourViewer emit).
 */

const DEFAULT_TITLE = 'Virtual Tour — VirtualTourEasy'
const DEFAULT_DESCRIPTION = 'View this 360° virtual tour powered by VirtualTourEasy.'
const DEFAULT_IMAGE = 'https://virtualtoureasy.com/images/og-image.jpg'
const SITE_NAME = 'VirtualTourEasy'

function setMeta(property: string, content: string, isName = false) {
  const attr = isName ? 'name' : 'property'
  let el = document.querySelector(`meta[${attr}="${property}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, property)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

export function setTourMeta(params: {
  title?: string | null
  description?: string | null
  image?: string | null
  url?: string
  orgName?: string | null
}) {
  const { title, description, image, url, orgName } = params

  // Build title: "Tour Title | VirtualTourEasy" or "Virtual Tour by Org | VirtualTourEasy"
  const displayTitle = title
    ? `${title} | ${SITE_NAME}`
    : orgName
    ? `Virtual Tour by ${orgName} | ${SITE_NAME}`
    : DEFAULT_TITLE

  const displayDescription = description || DEFAULT_DESCRIPTION
  const displayImage = image || DEFAULT_IMAGE
  const displayUrl = url || window.location.href

  // <title>
  document.title = displayTitle

  // Standard meta
  setMeta('description', displayDescription, true)

  // Open Graph
  setMeta('og:title', displayTitle)
  setMeta('og:description', displayDescription)
  setMeta('og:image', displayImage)
  setMeta('og:url', displayUrl)
  setMeta('og:type', 'website')
  setMeta('og:site_name', SITE_NAME)

  // Twitter Card
  setMeta('twitter:card', 'summary_large_image', true)
  setMeta('twitter:title', displayTitle, true)
  setMeta('twitter:description', displayDescription, true)
  setMeta('twitter:image', displayImage, true)
}

export function resetMeta() {
  document.title = DEFAULT_TITLE
}
